import type { ReactNode } from 'react'
import Box from '@mui/material/Box'
import Paper from '@mui/material/Paper'
import Typography from '@mui/material/Typography'

interface Props {
  /** What is absent, in the operator's terms — not "no rows". */
  title: string
  /** Why it is absent and what to do about it, when there is something to do. */
  hint?: string
  action?: ReactNode
}

/**
 * An intentional empty state.
 *
 * Most of this console is empty on a fresh installation, and an empty table
 * with column headers is indistinguishable from a failed query. Saying which
 * one it is, and what would fill it, is the difference between a screen that
 * looks broken and one that looks finished.
 */
export function EmptyState({ title, hint, action }: Props) {
  return (
    <Paper variant="outlined" sx={{ p: 5, textAlign: 'center' }}>
      <Typography variant="subtitle1" gutterBottom>
        {title}
      </Typography>
      {hint ? (
        <Typography variant="body2" color="text.secondary" sx={{ mb: action ? 2 : 0 }}>
          {hint}
        </Typography>
      ) : null}
      {action ? <Box sx={{ mt: 2 }}>{action}</Box> : null}
    </Paper>
  )
}
